<div class="mb-3 ctos-header">
    {{ _i18n._9421_PUBLISHED_OBSERVATIONS | translate }}
</div>

<div class="grid-header">
    <p class="cell lg">
        {{ _i18n._7347_OBSERVER | translate }}
    </p>
    <p class="cell">
        {{ _i18n._965_DATE | translate }}
    </p>
    <p class="cell">
        {{ _i18n._9785_INTERACTIONS | translate }}
    </p>
    <p class="cell">
        {{ _i18n._9784_NOTES | translate }}
    </p>
    <!--Will be translated-->
    <p class="cell">
        {{ _i18n._9786_OVERALL_OPPORTUNITY_TO_DEMONSTRATE | translate }}
    </p>
    <!--Will be translated-->
    <p class="cell">
        {{ _i18n._9787_OVERALL_WILLINGNESS_TO_TRY | translate }}
    </p>
    <!--Will be translated-->
    <p class="cell">
        {{ _i18n._9414_OVERALL_PROFICIENCY_SCORE | translate }}
    </p>
    <!-- <p class="cell">
        {{_i18n._9418_UNLINK | translate}}
    </p> -->
</div>
<div
    class="cmps-commitment-observations--grid-row"
    [class.cmps-commitment-observations--grid-row-last]="last"
    [attr.data-diffitemid]="r.ctx.e.diffItemId"
    *ngFor="let r of _rows; let last = last"
>
    <div
        class="cmps-commitment-observations--grid-row--content-top"
        (click)="_onToggleExpandClick(r.ctx.e.event.eventId)"
    >
        <p class="cell lg">
            {{ r.ctx.observer }}
        </p>
        <p class="cell">
            {{ r.ctx.e.event.sessionDate | cmpsDate: 'MMM-dd-y' }}
        </p>
        <p class="cell">
            {{ r.ctx.interactionsCount }}
        </p>
        <p class="cell">
            {{ r.ctx.notesCount }}
        </p>
        <p class="cell">
            <strong>
                {{
                    r.ctx.opportunityToDemonstrate == null
                        ? '-'
                        : (r.ctx.opportunityToDemonstrate
                          | cmpsPercent: '0.0-0')
                }}
            </strong>
        </p>
        <p class="cell">
            <strong>
                {{
                    r.ctx.willingnessToTry == null
                        ? '-'
                        : (r.ctx.willingnessToTry | cmpsPercent: '0.0-0')
                }}
            </strong>
        </p>
        <p class="cell">
            <strong>
                {{
                    r.ctx.proficiencyDelivered == null
                        ? '-'
                        : (r.ctx.proficiencyDelivered | cmpsPercent: '0.0-0')
                }}
            </strong>
        </p>
        <!-- <p class="cell">
            <button [disabled]="!r.ctx.e.event.published || disabled"
                    [attr.aria-label]="_i18n._9782_UNLINK_OBSERVATION | translate"
                    (click)="_onRemoveClick(r.ctx)">
                <cmps-icon svgIcon="link"></cmps-icon>
            </button>
        </p> -->
    </div>
    <div *ngIf="r.ctx.e.event.eventId === _expandedObservation">
        <div
            cmpsObservationNext
            [storePathPrefix]="'coachingCommitment.' + r.ctx.e.event.eventId"
            [mode]="_ObservationMode.REVIEW_READ_ONLY"
            [userId]="r.ctx.performerId"
            [observationId]="r.ctx.e.event.eventId"
            [filteredFocus]="[focus]"
            [displayProperties]="_displayProperties"
        ></div>
    </div>
</div>

<div class="d-flex justify-content-center pt-3">
    <button
        class="mx-3"
        [disabled]="_disabled || linkDisabled"
        (click)="_onSelectClick()"
        cmpsIconButton
    >
        <cmps-icon svgIcon="link"></cmps-icon>
        <span cmpsIconButtonLabel>{{
            _i18n._9780_LINK_ANOTHER_OBSERVATION | translate
        }}</span>
    </button>
    <button
        class="mx-3"
        [disabled]="_disabled"
        (click)="_onNewClick()"
        cmpsIconButton
    >
        <cmps-icon svgIcon="loupe"></cmps-icon>
        <span cmpsIconButtonLabel>{{
            _i18n._9781_START_A_NEW_OBSERVATION | translate
        }}</span>
    </button>
</div>
